import api from "lib/axios";
import type { ApiEnvelope } from "services/apiTypes";
import { unwrapData } from "services/apiTypes";

export type DashboardRecentStudent = {
  id: number;
  name: string;
  created_at: string | null;
};

export type DashboardRecentInstructor = {
  id: number;
  name: string;
  created_at: string | null;
};

export type DashboardRecentCourse = {
  id: number;
  title: string;
  created_at: string | null;
};

export type DashboardRecentEnrollment = {
  id: number;
  course_id: number;
  course_title: string;
  student_id: number;
  student_name: string;
  created_at: string | null;
};

export type DashboardSummary = {
  students_count: number;
  instructors_count: number;
  courses_count: number;
  active_students_count: number;
  active_instructors_count: number;
  enrollments_count: number;
  courses_with_enrollments_count: number;
  stages_count: number;
  classes_count: number;
  materials_count: number;
  recent: {
    students: DashboardRecentStudent[];
    instructors: DashboardRecentInstructor[];
    courses: DashboardRecentCourse[];
    enrollments: DashboardRecentEnrollment[];
  };
};

export const dashboardService = {
  async getSummary() {
    const response = await api.get<ApiEnvelope<{ data: DashboardSummary }>>("/mcp/dashboard/summary", {
      meta: { toastSuccess: false, toastError: false },
    });
    return unwrapData<DashboardSummary>(response.data);
  },
};
